/**
 * Polska odmiana rzeczownika po liczebniku: 1 pozycja, 2–4 (22–24, 32–34…)
 * pozycje, 0, 5–21 (w tym 12–14), 25–31… pozycji.
 */
export function polishPlural(n: number, forms: { one: string, few: string, many: string }): string {
  if (n === 1) return forms.one
  if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)) return forms.few
  return forms.many
}

export function polishProductPlural(n: number, useGenitive = false): string {
  if (useGenitive) {
    return n === 1 ? 'produktu' : 'produktów'
  }
  return polishPlural(n, { one: 'produkt', few: 'produkty', many: 'produktów' })
}
